import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const About = () => {
  return (
    <div className="about-page">
      <section className="about-hero">
        <h1 className="hero-title">
          <span className="gradient-text">Who We Are</span>
        </h1>
        <p className="tagline">
          More than builders. We're digital architects, experience designers, and technology pioneers.
        </p>
      </section>

      <section className="story-section">
        <p className="story-text">
          In a world saturated with cookie-cutter templates and mediocre websites, we saw an opportunity to do something different.
          Digital Avatar Studio was born from a simple belief: <strong>your digital presence should be as unique as your fingerprint</strong>.
        </p>
        <p className="story-text">
          We don't just code websites—we craft digital identities. Each project is a collaboration between your vision and our
          technical mastery, resulting in experiences that don't just look beautiful, but feel alive.
        </p>
        <p className="story-text">
          Our approach blends cutting-edge technology with human-centered design. We obsess over every pixel, every animation,
          every interaction because we know that in the digital realm, <strong>details create magic</strong>.
        </p>
      </section>

      <section className="section">
        <h2 className="section-title">Our <span className="gradient-text">Values</span></h2>

        <div className="about-grid">
          <div className="value-card glass">
            <h3 className="value-title">Purpose-Driven</h3>
            <p className="value-text">
              Every line of code serves a purpose. We don't build features for the sake of features—we create
              solutions that drive real business results.
            </p>
          </div>

          <div className="value-card glass">
            <h3 className="value-title">Innovation First</h3>
            <p className="value-text">
              We're constantly exploring new technologies, techniques, and paradigms. Standing still means falling behind,
              and we're always moving forward.
            </p>
          </div>

          <div className="value-card glass">
            <h3 className="value-title">Partnership</h3>
            <p className="value-text">
              Your success is our success. We don't just deliver projects and disappear—we build lasting relationships
              based on trust and mutual growth.
            </p>
          </div>

          <div className="value-card glass">
            <h3 className="value-title">Craft Excellence</h3>
            <p className="value-text">
              We're perfectionists who sweat the small stuff. From typography to transitions, every detail receives
              meticulous attention and care.
            </p>
          </div>

          <div className="value-card glass">
            <h3 className="value-title">Global Impact</h3>
            <p className="value-text">
              We build for the world. Our solutions work flawlessly across cultures, languages, and devices,
              reaching audiences wherever they are.
            </p>
          </div>

          <div className="value-card glass">
            <h3 className="value-title">Speed & Quality</h3>
            <p className="value-text">
              Fast delivery doesn't mean compromised quality. We've perfected our process to deliver exceptional
              results without the traditional wait times.
            </p>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <h2 className="cta-title">
          Ready to Work <span className="gradient-text">Together</span>?
        </h2>
        <p className="cta-subtitle">
          Let's turn your vision into a digital reality that exceeds expectations.
        </p>
        <Link to="/contact" className="cta-button">Start a Conversation</Link>
      </section>
    </div>
  );
};

export default About;
